import { Box, Button, Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Field } from 'react-final-form'
import { CustomTextField } from '../../../components/CustomDisabledFields'

const EntregasFields = ({ entregas, showError, cannotUpdate }) => {
  const [rowsEntregas, setRowsEntregas] = useState(1)

  useEffect(() => {
    setRowsEntregas(entregas?.length)
  }, [entregas])

  return (
    <>
      <Grid container spacing={2}>
        {[...Array(rowsEntregas).keys()].map(i => (
          <Grid key={i} item xs={12}>
            <Field
              fullWidth
              component={CustomTextField}
              label={`Entrega Nº ${i + 1}`}
              name={`entregas[${i}].nome`}
              showError={showError}
              disabled={cannotUpdate}
            />
          </Grid>
        ))}
      </Grid>
      <Box m={2} />
      <Grid item xs={12}>
        <Grid container alignItems="flex-end" justifyContent="flex-end">
          <Grid item>
            <Button
              variant="outlined"
              disabled={rowsEntregas <= 1 || cannotUpdate}
              onClick={() => {
                if (rowsEntregas > 1) setRowsEntregas(rowsEntregas - 1)
              }}
            >
              -
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setRowsEntregas(rowsEntregas + 1)
              }}
              disabled={cannotUpdate}
            >
              +
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default React.memo(EntregasFields)
